var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { IsArray, IsNotEmpty, IsNumberString, IsOptional, IsString, Length, ValidateNested, } from 'class-validator';
class CustomerInfoDto {
}
__decorate([
    IsString(),
    IsNotEmpty(),
    __metadata("design:type", String)
], CustomerInfoDto.prototype, "name", void 0);
__decorate([
    IsNumberString(),
    Length(4, 8),
    IsOptional(),
    __metadata("design:type", String)
], CustomerInfoDto.prototype, "phoneNumberSuffix", void 0);
__decorate([
    IsString(),
    Length(10, 10),
    IsOptional(),
    __metadata("design:type", String)
], CustomerInfoDto.prototype, "driverLicenseNumberPrefix", void 0);
export class CheckBlackListQueryDto {
    constructor() {
        this.customerInfos = [];
    }
}
__decorate([
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => CustomerInfoDto),
    __metadata("design:type", Array)
], CheckBlackListQueryDto.prototype, "customerInfos", void 0);
